/**
 * Created by Ning Jiang on 2021-07-02.
 */

import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {GameIntroViewConfig} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {TombstoneRipEntryView} from "./TombstoneRipEntryView";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Layers} from "../view/TombstoneRipLayers";
import {TombstoneRip} from "../TombstoneRip";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class TombstoneRipIntroPlugin extends NolimitGameIntroPlugin {

    private _entryView:TombstoneRipEntryView;
    private _config:GameIntroViewConfig;

    constructor(config:GameIntroViewConfig) {
        super(config);

        config.onResize = () => {
            if(this._view?.soundSetting) {
                this._view.soundSetting.position.set(NolimitApplication.screenBounds.left + 20, 675);
            }
        };
        this._config = config;
    }

    public async getReady():Promise<NolimitPlugin> {
        await super.getReady();

        if(this.showEntryPage()) {
            this._entryView = new TombstoneRipEntryView();
            this._entryView.show();
            if ((<any>this._view).soundButton !=  undefined){
                this._entryView.addChild((<any>this._view).soundButton);
            }
            this._entryView.addChild((<any>this._view).soundButton);
            this._view.slideShow.navToIndex(1);
            this._view.slideShow.stop();
        }

        return Promise.resolve(this);
    }

    public async getReadyToStart():Promise<NolimitPlugin> {
        NolimitApplication.getLayerByName(Layers.FOREGROUND_TOP)!.interactiveChildren = false;
        if(this.showEntryPage()) {
            NolimitApplication.getLayerByName("INTRO")!.interactiveChildren = false;
            await this._entryView.complete();
            if ((<any>this._view).soundButton !=  undefined){
                this._entryView.addChild((<any>this._view).soundButton);
            }
            this._view.slideShow.start();
            NolimitApplication.getLayerByName("INTRO")!.interactiveChildren = true;
        }
        return super.getReadyToStart();
    }

    private showEntryPage():boolean {
        if(TombstoneRip.model.parsedInitData.isRestoreState) {
            return false;
        }

        if(SlotGame.apiPlugin.isReplay) {
            return false;
        }

        return true;
    }
}